import { FlexColumn, FlexRow, useMoment } from '@gorila-shared-ui/components';
import { Tag } from 'baseui/tag';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { jobsFiltersState, jobsStatusState } from '../../storage/jobStates';
import { LabelXSmall } from 'baseui/typography';

type Props = Readonly<{
  disabledStatusFilter?: boolean;
}>;

function JobsSelectedFilters({ disabledStatusFilter = false }: Props) {
  const { css } = useStyles();
  const [filters, setFilters] = useRecoilState(jobsFiltersState);
  const { formatDateFromTs } = useMoment();
  const jobStatusList = useRecoilValue(jobsStatusState);

  const onClearFilter = (field: keyof typeof filters) => {
    setFilters((prev) => ({
      ...prev,
      [field]: undefined,
    }));
  };

  const onRemoveStatusFilter = (status: number) => {
    setFilters((prev) => {
      const newStatuses = prev.jobStatus ? prev.jobStatus.filter((jobStatus) => +jobStatus !== +status) : undefined;
      return {
        ...prev,
        jobStatus: newStatuses,
      };
    });
  };

  return (
    <FlexRow gap={'4px'} classNames={css({ alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' })}>
      <FlexRow
        gap={0}
        classNames={css({ flexWrap: 'wrap'})}
      >
        {filters.user && (
          <Tag
            variant="solid"
            onActionClick={() => {
              onClearFilter('user');
            }}
          >
            {filters.user.name}
          </Tag>
        )}
        {filters.tenant && (
          <Tag
            variant="solid"
            onActionClick={() => {
              onClearFilter('tenant');
            }}
          >
            {filters.tenant.name}
          </Tag>
        )}
        {filters.jobType && (
          <Tag
            variant="solid"
            onActionClick={() => {
              onClearFilter('jobType');
            }}
          >
            {filters.jobType.name}
          </Tag>
        )}
        {!disabledStatusFilter &&
          filters.jobStatus &&
          filters.jobStatus.map((status) => (
            <Tag
              variant="solid"
              onActionClick={() => {
                onRemoveStatusFilter(status);
              }}
            >
              {jobStatusList?.find((item) => +item.value === +status)?.name}
            </Tag>
          ))}
      </FlexRow>
      {filters.startDate && filters.endDate && (
        <FlexColumn gap={0} classNames={css({ alignItems: 'flex-end' })}>
          <LabelXSmall>
            Del {formatDateFromTs(filters.startDate, 'DD/MM/yyyy')}
          </LabelXSmall>
          <LabelXSmall>
            Al {formatDateFromTs(filters.endDate, 'DD/MM/yyyy')}
          </LabelXSmall>
        </FlexColumn>
      )}
    </FlexRow>
  );
}

export default JobsSelectedFilters;
